import { useAtom } from 'jotai';
import cn from 'classnames';

import { isDisableHelpersAtom } from '../../../../store/index.atom';
import KeyPressLayer from '../../Layer/KeyPressLayer';

import DesktopPageIndicator from './DesktopPageIndicator';
import DesktopPageMoveButton from './DesktopPageMoveButton';
import * as Styled from './index.styles';

interface Props {
  updatePrevThumbnails?: (page: number) => void;
  updateNextThumbnails?: (page: number) => void;
  totalPage: number;
  ctaFormPage?: number;
  isMoveCtaFormPageRequirements: boolean;
  isNextPageButtonDisabled?: boolean;
}

const DesktopPageNavigationButton = ({
  updatePrevThumbnails,
  updateNextThumbnails,
  totalPage,
  ctaFormPage,
  isMoveCtaFormPageRequirements,
  isNextPageButtonDisabled,
}: Props) => {
  const [isDisableHelpers, setIsDisableHelpers] = useAtom(isDisableHelpersAtom);

  return (
    <KeyPressLayer
      totalPage={totalPage}
      updateNextThumbnails={updateNextThumbnails}
      updatePrevThumbnails={updatePrevThumbnails}
      isNextPageButtonDisabled={isNextPageButtonDisabled}
    >
      <Styled.PageNavigationButton
        className={cn({
          disabled: isDisableHelpers,
        })}
        onClick={() => {
          if (isDisableHelpers) {
            setIsDisableHelpers(false);
            return;
          }
        }}
      >
        <DesktopPageMoveButton
          variant="prev"
          totalPage={totalPage}
          updatePrevThumbnails={updatePrevThumbnails}
        />
        <DesktopPageIndicator
          totalPage={totalPage}
          ctaFormPage={ctaFormPage}
          isMoveCtaFormPageRequirements={isMoveCtaFormPageRequirements}
        />
        <DesktopPageMoveButton
          variant="next"
          totalPage={totalPage}
          isNextPageButtonDisabled={isNextPageButtonDisabled}
          updateNextThumbnails={updateNextThumbnails}
        />
      </Styled.PageNavigationButton>
    </KeyPressLayer>
  );
};

export default DesktopPageNavigationButton;
